<template>
  <div id="app">
    <HEADER></HEADER>
    <div style="width: 100%">
      <router-view />
    </div>
    <FOOTER></FOOTER>
  </div>
</template>

<script>
import HEADER from "@/components/header";
import FOOTER from "@/components/footer";
export default {
  components: {
    HEADER,
    FOOTER,
  },
};
</script>

<style lang="scss">
@import "~bootstrap";
@import "~bootstrap-vue";
* {
  padding: 0;
  margin: 0;
}
</style>
